function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_111595_17653)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.3807 16.3357C17.1716 10.6882 7.82355 10.6882 1.62424 16.3357C0.800282 17.0833 0.800282 18.4068 1.5752 19.2049L2.75228 20.4172C3.44872 21.1345 4.55714 21.1951 5.32224 20.5688L7.25462 18.9826C7.71565 18.6088 7.9903 18.033 7.9903 17.4167V14.8203C10.9134 13.8403 14.0817 13.8302 17.0146 14.8203V17.4268C17.0146 18.033 17.2893 18.6088 17.7503 18.9927L19.6729 20.5688C20.4478 21.1951 21.5464 21.1345 22.2428 20.4172L23.4199 19.2049C24.2046 18.4068 24.1948 17.0833 23.3807 16.3357ZM6.61704 9.06168C7.15653 9.06168 7.59794 8.60705 7.59794 8.0514V6.46526L11.757 10.7488C12.1395 11.1428 12.7575 11.1428 13.14 10.7488L18.6919 5.03066C19.0745 4.63665 19.0745 4.00018 18.6919 3.60617C18.3094 3.21216 17.6914 3.21216 17.3089 3.60617L12.4534 8.60705L8.9712 5.02056H10.5406C11.0801 5.02056 11.5216 4.56593 11.5216 4.01028C11.5216 3.45463 11.0801 3 10.5406 3H6.61704C6.07754 3 5.63613 3.45463 5.63613 4.01028V8.0514C5.63613 8.60705 6.07754 9.06168 6.61704 9.06168Z",
  fill: "#E53935"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_111595_17653"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgFailedIncoming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIncoming);
export default __webpack_public_path__ + "static/media/FailedIncoming.5aa47cda.svg";
export { ForwardRef as ReactComponent };